import { Card, Flex } from '@servicetitan/anvil2';
import { Form, LoanFormData } from './Form';
import { FinancedAmountStore } from './financedAmountStore';
import { SubmitHandler } from 'react-hook-form';
import { toNumber } from '@servicetitan/anvil2-react-hook-form';

interface SecondLookContainerProps {
    showProviderSelection?: boolean;
    onSubmitAction?: () => void;
}

export const SecondLookContainer = ({
    showProviderSelection,
    onSubmitAction,
}: SecondLookContainerProps) => {
    const { setFinancedAmount } = FinancedAmountStore.useStore();

    const onSubmit: SubmitHandler<LoanFormData> = data => {
        const saleAmountValue = toNumber(data.saleAmount);
        const downPaymentValue = toNumber(data.downPayment);

        setFinancedAmount({
            saleAmount: saleAmountValue,
            downPayment: downPaymentValue,
        });

        onSubmitAction?.();
    };

    return (
        <Card style={{ width: '100%' }}>
            <Flex
                justifyContent="space-between"
                sm={{ direction: 'column' }}
                lg={{ direction: 'row' }}
                style={{ width: '100%' }}
            >
                <Form
                    onSubmit={onSubmit}
                    showProviderSelection={showProviderSelection}
                    primaryButtonText="Prequalify Now"
                />
            </Flex>
        </Card>
    );
};
